import { Paper, Stack, useTheme } from '@mui/material';
import { OrganizationProfessionalVisitHistoryContent } from 'src/sections/@dashboard/organization/components/OrganizationProfessionals/OrganizationProfessional/OrganizationProfessionalVisitHistoryContent';

export default function OrganizationProfessionalTabsVisitHistoryPage() {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        borderRadius: 2,
        boxShadow: theme.customShadows.z8,
        height: 1,
      }}
    >
      <Stack sx={{ height: 1, minHeight: '560px' }}>
        <OrganizationProfessionalVisitHistoryContent />
      </Stack>
    </Paper>
  );
}
